/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AddFittingComponent } from '../add-fitting-size/add-fitting.component';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { ActionPageEnumDto, ActionTypeEnumDto } from 'api/models';
import { FittingsManagementService } from 'api/services';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';


@Component({
  selector: 'app-delete-fitting-size',
  templateUrl: './delete-fitting-size.component.html'
})
export class DeleteFittingSizeComponent extends AddFittingComponent implements OnInit, OnDestroy {
  onDeleteContextMenuPosition = { x: '0px', y: '0px' };

  @ViewChild(MatMenuTrigger) onDeleteContextMenu: MatMenuTrigger;

  ngOnInit() {
    this.refreshSubscription = this.fittingSizeManagementService.
      getFittingTableData().subscribe(
        () => {
          this.refresh();
          this.selectedRowCopy = this.fittingSizeManagementService.getSelectedRowCopy();
        }
      );
    this.actionPage = ActionPageEnumDto.Delete;
    this.actionType = ActionTypeEnumDto.UndoDelete;
    this.resetExistingFittingSizeDataTable();
    this.setTableHeaders();
    this.getFittingsData();
    this.fittingSizeManagementService.setActionPage(this.actionPage);
  }

  constructor(
    public dialog: MatDialog,
    public userHandlerService: UserHandlerService,
    public fittingsManagementService: FittingsManagementService,
    public genericTableDataService: GenericTableData,
    public fittingSizeDataService: FittingSizeDataService,
    public fittingSizeManagementService: FittingSizeManagementService,
    public authentificationService: AuthentificationService,
    public loaderService: LoaderService
  ) {
    super(dialog, userHandlerService, fittingsManagementService, genericTableDataService,
      fittingSizeDataService, fittingSizeManagementService, authentificationService, loaderService);
  }


  getSentForAproveActionType() {
    return ActionTypeEnumDto.SendForApproveDeletedSize;
  }

  getDeleteActionType() {
    return ActionTypeEnumDto.RemoveDeletedAfterPartialSave;
  }

  getFittingType() {
    return this.fittingSizeManagementService.getSelectedFittingType();
  }
  onDeleteAction(selectedSize: any) {
    this.fittingSizeManagementService.setExistingFittingSize(selectedSize);
  }

  getPartialSaveActionType() {
    return ActionTypeEnumDto.PartialSaveDelete;
  }


  onDeleteContextMenuClick(deleteEvent) {
    this.onDeleteContextMenuPosition.x = deleteEvent.mouseEvent.clientX + 'px';
    this.onDeleteContextMenuPosition.y = deleteEvent.mouseEvent.clientY + 'px';
    // tslint:disable-next-line: object-literal-key-quotes
    this.onDeleteContextMenu.menuData = { 'element': deleteEvent.element };
    this.onDeleteContextMenu.openMenu();
  }
}
